export default __webpack_public_path__ + "static/media/atomichub-logo.a16f37d0.png";